const mutations = {
  SET_FEEDBACK_COMPLAINT(state, { type, data }) {
    const map = {
      detail: 'detail',
      internalIssue: 'internalIssue',
      customerIssue: 'customerIssue',
      settlementIssue: 'settlementIssue',
    }

    if (map[type]) {
      state.feedbackComplaint[map[type]] = data
    }
  },
  CLEAR_FEEDBACK_COMPLAINT(state) {
    for (const data of Object.keys(state.feedbackComplaint)) {
      state.feedbackComplaint[data] = null
    }
  }
}

export default mutations
